var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{class:_vm.$style.wraper},[(!this.$route.query.a)?_c('registration-header'):_vm._e(),_c('br'),_c('registration-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }